const events = {
  namespaced: true,
  state: {
    status: false,
  },
  actions: {
    setStatus({ state }, status) {
      state.status = status
      setTimeout(function () {
        if (state.status) {
          state.status = false
        }
      }, 20000)
    },
  },
}

export default events
